'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { Component } = React;
const ReactModal = require('react-modal');
const animationFrame = require('../utils/requestAnimationFrame');
const root = require('bunsen/helpers/windowCheck');

/**
 * Wrapper class for the `react-modal` component.
 */
class Modal extends Component {
    constructor(props) {
        super(props);

        const { isOpen, onRequestClose } = props;

        this._onRequestClose = this._onRequestClose.bind(this, onRequestClose);
        this.state = { opaque: !!isOpen };
    }

    componentWillReceiveProps({ isOpen: nextIsOpen }) {
        const { isOpen } = this.props;

        // Allow opening/closing via a prop.
        if (nextIsOpen && !isOpen) {
            this._handleOpen();
            return;
        }

        if (!nextIsOpen && isOpen) {
            this._handleClose();
            return;
        }
    }

    _onRequestClose(callback) {
        if (this.props.canClose) {
            callback();
        }
    }

    _handleOpen() {
        // Fade in on open.
        animationFrame(() => this.setState({ opaque: true }));
        this._addBodyClass();
    }

    _handleClose() {
        // Fade out on close.
        animationFrame(() => this.setState({ opaque: false }));
        this._removeBodyClass();
    }

    _addBodyClass() {
        if (this.props.addBodyClass) {
            root.document.getElementsByTagName('body')[0].classList.add('dibsModal__Body--open');
        }
    }

    _removeBodyClass() {
        if (this.props.addBodyClass) {
            root.document.getElementsByTagName('body')[0].classList.remove('dibsModal__Body--open');
        }
    }

    render() {
        const { transitionDuration, children, style: extraStyle } = this.props;
        const { opaque } = this.state;

        const style = {
            content: Object.assign(
                {
                    opacity: opaque ? 1 : 0,
                    transition: `opacity ${transitionDuration}ms linear`,
                },
                extraStyle.content
            ),
            overlay: Object.assign(
                {
                    zIndex: 1000,
                },
                extraStyle.overlay
            ),
        };

        return (
            <ReactModal
                {...this.props}
                onRequestClose={this._onRequestClose}
                closeTimeoutMS={transitionDuration}
                style={style}
            >
                {children}
            </ReactModal>
        );
    }
}

Modal.propTypes = {
    isOpen: PropTypes.bool,
    addBodyClass: PropTypes.bool,
    transitionDuration: PropTypes.number,
    children: PropTypes.node,
    canClose: PropTypes.bool,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object,
    }),
};

Modal.defaultProps = {
    isOpen: false,
    addBodyClass: true,
    transitionDuration: 250,
    canClose: true,
    style: {},
    onRequestClose: () => {},
};

module.exports = Modal;



// WEBPACK FOOTER //
// ./assets/js/global/components/Modal.jsx